export const DEFAULT_TESTIMONIAL_BADGE = "WHAT OUR CREATORS SAY";
export const CREATOR_TESTIMONIAL_TARGET_ID = "creator-stories-section";
export const DEFAULT_AUTHOR_NAME = "Rajiv Talreja";
export const DEFAULT_AUTHOR_COMPANY = "Quantum Leap";
export const DEFAULT_AUTHOR_ROLE = "Business/ MSME Coach";
export const DEFAULT_AUTHOR_SUBTITLE = "Founder Quantum Leap";
export const DEFAULT_RATING_SCORE = "5.0";
export const DEFAULT_RATING_MAX = 5;
export const DEFAULT_QUOTE_TEXT =
  "Exly simplified our operations with an intuitive all-in-one dashboard and seamless workflows. Their responsive support, quick resolutions, and smooth platform experience made scaling much easier for us.";
export const DEFAULT_PHOTO_PLACEHOLDER_LABEL = "Photo";
export const DEFAULT_PHOTO_URL =
  "https://lpcdn.exlyapp.com/lp/static/images/home_page_v2/referral_page/rajiv-talreja.png";

export const DEFAULT_CREATOR_TESTIMONIAL = {
  badge: DEFAULT_TESTIMONIAL_BADGE,
  authorName: DEFAULT_AUTHOR_NAME,
  companyName: DEFAULT_AUTHOR_COMPANY,
  role: DEFAULT_AUTHOR_ROLE,
  subtitle: DEFAULT_AUTHOR_SUBTITLE,
  rating: DEFAULT_RATING_SCORE,
  maxStars: DEFAULT_RATING_MAX,
  quote: DEFAULT_QUOTE_TEXT,
  photoUrl: DEFAULT_PHOTO_URL,
  photoPlaceholderText: DEFAULT_PHOTO_PLACEHOLDER_LABEL,
};

export const NITYA_KHURANA_NAME = "Nitya Khurana";
export const NITYA_KHURANA_ROLE = "Yoga & Wellness Coach";
export const NITYA_KHURANA_SUBTITLE = "Founder PregaYog";
export const NITYA_KHURANA_QUOTE =
  "Exly has made managing our website, consultation classes, recorded content access, and payments extremely seamless. Both Indian and international payments work smoothly, and the platform is very easy to use for our team as well as users.";
export const NITYA_KHURANA_PHOTO_URL =
  "https://lpcdn.exlyapp.com/lp/static/images/home_page_v2/referral_page/nitya-khurana.png";

export const NITYA_KHURANA_TESTIMONIAL = {
  badge: DEFAULT_TESTIMONIAL_BADGE,
  authorName: NITYA_KHURANA_NAME,
  companyName: "",
  role: NITYA_KHURANA_ROLE,
  subtitle: NITYA_KHURANA_SUBTITLE,
  rating: DEFAULT_RATING_SCORE,
  maxStars: DEFAULT_RATING_MAX,
  quote: NITYA_KHURANA_QUOTE,
  photoUrl: NITYA_KHURANA_PHOTO_URL,
  photoPlaceholderText: DEFAULT_PHOTO_PLACEHOLDER_LABEL,
};

export const ROCHIT_SINGH_NAME = "Rochit Singh";
export const ROCHIT_SINGH_ROLE = "SEBI Registered Research Analyst";
export const ROCHIT_SINGH_QUOTE =
  "Exly is very easy to use with seamless website payments, bookings, SEBI compliance, and webinar integration. Unlike any other platform I’ve used before, the setup is simple, reliable, and the team is always quick to help whenever needed.";
export const ROCHIT_SINGH_PHOTO_URL =
  "https://lpcdn.exlyapp.com/lp/static/images/home_page_v2/referral_page/rochit-singh.png";

export const ROCHIT_SINGH_TESTIMONIAL = {
  badge: DEFAULT_TESTIMONIAL_BADGE,
  authorName: ROCHIT_SINGH_NAME,
  companyName: "",
  role: ROCHIT_SINGH_ROLE,
  subtitle: "",
  rating: DEFAULT_RATING_SCORE,
  maxStars: DEFAULT_RATING_MAX,
  quote: ROCHIT_SINGH_QUOTE,
  photoUrl: ROCHIT_SINGH_PHOTO_URL,
  photoPlaceholderText: DEFAULT_PHOTO_PLACEHOLDER_LABEL,
};
